import { render, staticRenderFns } from "./CompanyDelivery.vue?vue&type=template&id=431556f2&scoped=true&"
import script from "./CompanyDelivery.vue?vue&type=script&lang=js&"
export * from "./CompanyDelivery.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDelivery.vue?vue&type=style&index=0&id=431556f2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431556f2",
  null
  
)

export default component.exports